import dataAnalyst from './assets/data-analyst.png';
import mediaBuyer from './assets/media-buyer.png';
import mediaFinance from './assets/media-finance.png';
import mediaOptimization from './assets/media-optimization.png';
import mediaPlanner from './assets/media-planner.png';
import mediaStrategist from './assets/media-strategist.png';
import offlinePlanner from './assets/offline-planner.png';
import projectManager from './assets/project-manager.png';
import qualityAssurance from './assets/quality-assurance.png';
import reportingSpecialist from './assets/reporting-specialist.png';
import supervisor from './assets/supervisor.png';
import trafficker from './assets/trafficker.png';
import voiceAgent from './assets/voice-agent.png';

export const AvatarAiRoles = {
  dataAnalyst: dataAnalyst,
  mediaBuyer: mediaBuyer,
  mediaFinance: mediaFinance,
  mediaOptimization: mediaOptimization,
  mediaPlanner: mediaPlanner,
  mediaStrategist: mediaStrategist,
  offlinePlanner: offlinePlanner,
  projectManager: projectManager,
  qualityAssurance: qualityAssurance,
  supervisor: supervisor,
  trafficker: trafficker,
  voiceAgent: voiceAgent,
  reportingSpecialist: reportingSpecialist,
};

export const AvatarAiPaddings = {
  xsmall: '1px',
  small: '1px',
  medium: '1.5px',
  large: '2px',
  mega: '3px',
};
